import { mapGetters } from 'vuex'

export const leagueSelector = {
  data () {
    return {
      selectedLeague: null
    }
  },
  computed:
  {
    ...mapGetters({
      leagueList: 'leagueNameList'
    })
  },
  watch: {
    leagueList: function (val) {
      if (this.leagueList) {
        this.selectedLeague = this.leagueList[this.leagueList.length - 1]
      }
    }
  },
  created () {
    this.$store.dispatch('getLeagueList')
  }
}



// WEBPACK FOOTER //
// ./src/components/common/league-selector.mixin.js